import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import styles from "./AddExampleContentDialogMessage.module.less";
import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { formatList } from "client/Misc/cultureSpecificUtils";
import { hubItemKeyPerKind } from "client/Features/Settings/Analytics/HubUsageDialog";

export type AddExampleDialogMessageProps = {
	hubItemKinds: readonly HubItemKind[];
};

export const AddExampleDialogMessage = (props: AddExampleDialogMessageProps): ReactElement => {
	const {
		hubItemKinds
	} = props;

	return (
		<span className={styles.addExampleDialogMessage}>
			<span>
				<FormattedText
					text={localize("_CreateHubDummyDataDescription")}
					thingsToReplace={[
						{
							what: "{{HubItemKinds}}",
							filler: (
								<b>
									{formatList(
										hubItemKinds.map(
											x => localize(hubItemKeyPerKind[x])
										)
									)}
								</b>
							)
						}
					]}
				/>
			</span>
			<Typography
				textColor="secondary"
				size="body-small"
				isItalic
			>
				{localize("_CreateHubDummyDataDescriptionSubtitle")}
			</Typography>
		</span>
	);
};
AddExampleDialogMessage.displayName = "AddExampleDialogMessage";